import apiFetch from '../apiFetch'

export default function (token, organizedUnitId) {
  return apiFetch({ endPoint: `processingAgency/GetAllProcessingAgencyCombo/${organizedUnitId}`, method: 'GET', token: token })
}
